var map = {
	"./Nochnoe_nebo.png": 85,
	"./birds_lake.jpg": 86,
	"./black.png": 87,
	"./dawn_lake.jpg": 88,
	"./day_lake.jpg": 89,
	"./evening_lake.jpg": 90,
	"./theend.jpg": 91,
	"./Белашья 4.jpg": 92,
	"./Дневное небо.png": 93,
	"./Еня 3.jpg": 94,
	"./Еня 4.jpg": 95,
	"./Еня.jpg": 96,
	"./Лесная День.jpg": 97,
	"./Лесная Ночь.jpg": 98,
	"./Перелесье гусь 2.jpg": 99,
	"./Перелесье гусь 3.jpg": 100,
	"./Перелесье гусь 4.jpg": 101,
	"./Поломанный.jpg": 102,
	"./Починенный.jpg": 103,
	"./СЛ вечер.jpg": 104,
	"./СЛ день.jpg": 105,
	"./СЛ ночь.jpg": 106,
	"./Северная день.jpg": 107,
	"./Северная ночь.jpg": 108,
	"./Сентябрьская день.jpg": 109,
	"./Сентябрьская ночь.jpg": 110,
	"./Южный Лес вечер.jpg": 111,
	"./Южный Лес день.jpg": 112,
	"./Южный Лес ночь.jpg": 113,
	"./дом ени.jpg": 114,
	"./дом жанетт.jpg": 115,
	"./дубрава.png": 116,
	"./кафетерий.jpg": 117,
	"./комната гг 3.jpg": 118,
	"./комната гг 5.jpg": 119,
	"./комната гг 7.jpg": 120,
	"./корридор гг 2.jpg": 121,
	"./корридор гг 3.jpg": 122,
	"./корридор гг 5.jpg": 123,
	"./кустики.jpg": 124,
	"./лесная поляна ночью.png": 125,
	"./лесная поляна с Еней.png": 126,
	"./мост.jpg": 127,
	"./наряженный домик 4.jpg": 128,
	"./окно.jpg": 129,
	"./парк.jpg": 130,
	"./порог школы 2.jpg": 131,
	"./порог школы стенгазета.jpg": 132,
	"./прибранный домик 2.jpg": 133,
	"./школа корридор 2.jpg": 134,
	"./школа корридор.jpg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;